import {
  FormControl,
  LinearProgress,
  MenuItem,
  Select,
  Theme,
  WithStyles,
} from "@material-ui/core";
import { bindActions, mockTheme } from "../utils/utils";
import * as React from "react";
import { ComponentClass } from "react";
import { connect } from "react-redux";
import { IStore } from "../store";
import { ISubmitEvent, UiSchema } from "react-jsonschema-form";
import { ClientActions, ClientState } from "../store/client";
import { JSONSchema6 } from "json-schema";
import { Client } from "../api/model";
import { getApi } from "../api/ApiProvider";

// components
import AsyncTable, { ColumnDefinition } from "../components/AsyncTable";
import EnhancedSchemaForm from "../components/schemaForm";
import SearchBox from "../components/SearchBox";

// material
import Grid from "@material-ui/core/Grid";
import { SortDirection } from "@material-ui/core/TableCell";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/ModeEdit";
import withStyles from "@material-ui/core/styles/withStyles";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import blue from "@material-ui/core/colors/blue";
import { Star, StarBorder } from "@material-ui/icons";
import InfoIcon from "@material-ui/icons/Info";

const styles = (theme: Theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: `calc(50% - ${theme.spacing.unit * 3}px)`,
  },
  menu: {
    width: 200,
  },

  routeSelector: {
    width: "100%",
    height: "100%",
  },
  buttons: {
    marginLeft: "auto",
  },
  abm: {
    padding: theme.spacing.unit * 3,
    margin: theme.spacing.unit,
  },

  root: {
    flexGrow: 1,
  },
  editIcon: {
    color: blue["500"],
    marginLeft: 2,
  },
  starDefault: {
    float: "right",
  },
  starIconDefault: {
    color: "#ff0",
    borderColor: "#000",
    paddingTop: 5,
  },
  starBorderIcon: {
    paddingTop: 5,
  },
  closeButton: {
    textAlign: "right",
  },
});

/**
 * This is a hack to has a object with the keys the same as the return of the #createStyles
 */
const classesType = styles(mockTheme);

interface ClientsProps extends WithStyles<keyof typeof classesType> {
  actions: ClientActions;
  data: ClientState;
  user: any;
}

interface ClientsState {
  abm: {
    id: string;
    name: string;
    document: string;
    email: string;
    phone: string | undefined;
    address: string | undefined;
    open: boolean;
  };
  openAddress: boolean;
  selectedLocationDefault: string | undefined;
  location: {
    id: number;
    street1: string;
    street2: string;
    number: string;
    observation: string;
    lat: number;
    lng: number;
    defaultLocation: boolean;
  };
  table: {
    data: any;
    sortBy: string;
    sortDirection: SortDirection;
    columnData: ColumnDefinition[];
  };
  dataLoading: boolean;
  searchText: string;
  schema: any;
  schemaAddress: any;
  clientLocations: any;
}

const schema: JSONSchema6 = {
  title: "Cliente",
  type: "object",
  required: ["name", "document", "email", "phone"],
  properties: {
    name: { type: "string", title: "Nombre" },
    document: { type: "string", title: "Documento" },
    email: { type: "string", title: "Correo electrónico", format: "email" },
    phone: { type: "string", title: "Telefono" },
  },
};

const schemaAddress: JSONSchema6 = {
  title: "Direcciones",
  type: "object",
  required: ["street1"],
  properties: {
    id: {
      type: "number",
      title: "Elige la dirección a editar",
      anyOf: [{ type: "number", enum: [0], title: "Cargando" }],
      default: 0,
    },
    street1: { type: "string", title: "Calle 1" },
    street2: { type: "string", title: "Calle 2" },
    number: { type: "string", title: "Número" },
    observation: { type: "string", title: "Observación" },
  },
};

const uiSchema: UiSchema = {
  blendMode: {
    "ui:enumDisabled": ["multiply"],
  },
};

class Clients extends React.Component<ClientsProps, ClientsState> {
  constructor(props: ClientsProps) {
    super(props);

    this.state = {
      abm: {
        id: "",
        name: "",
        document: "",
        email: "",
        phone: "",
        address: "",
        open: false,
      },
      openAddress: false,
      selectedLocationDefault: "",
      dataLoading: false,
      location: {
        id: 0,
        street1: "",
        street2: "",
        number: "",
        observation: "",
        lat: 0,
        lng: 0,
        defaultLocation: false,
      },
      table: {
        data: [],
        sortBy: "name",
        sortDirection: "desc",
        columnData: [
          {
            path: "document",
            numeric: false,
            disablePadding: false,
            label: "CI / RUC",
          },
          {
            path: "user.name",
            numeric: false,
            disablePadding: false,
            label: "Nombre",
          },
          {
            path: "user.email",
            numeric: false,
            disablePadding: false,
            label: "Correo",
          },
          {
            path: "phone",
            numeric: true,
            disablePadding: false,
            label: "Teléfono",
          },
        ],
      },
      searchText: "",
      schema: schema,
      schemaAddress: schemaAddress,
      clientLocations: [],
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.showDialog = this.showDialog.bind(this);
    this.hideDialog = this.hideDialog.bind(this);
    this.filter = this.filter.bind(this);
  }

  addColumnAddress(refresh: boolean) {
    const clients = this.props.data.data.data;
    const documents = clients.filter((d) => d.document !== null);
    documents.map((l) => this.getLocationsByClientDocument(l.document, true));

    if (!refresh) {
      setTimeout(() => {
        this.setState({
          table: {
            ...this.state.table,
            columnData: [
              ...this.state.table.columnData,
              {
                path: "",
                numeric: true,
                disablePadding: false,
                label: "Dirección preferida",
                draw: (cd: ColumnDefinition, data: Client) => {
                  const document = data.document;
                  const filterLocations =
                    this.filterLocationsDocument(document);

                  const defaultLocationData = filterLocations.map((l: any) =>
                    l[document].filter((location: any) => {
                      return location.defaultLocation === true;
                    })
                  );

                  const dataAuxiliar = defaultLocationData[0];
                  const dataFinal =
                    dataAuxiliar && dataAuxiliar[0] ? dataAuxiliar[0].id : "";

                  return (
                    <>
                      <FormControl style={{ width: 200 }}>
                        <Select
                          value={
                            this.state.selectedLocationDefault.length
                              ? this.state.selectedLocationDefault
                              : dataFinal
                          }
                          inputProps={{
                            name: "location",
                            id: "clientLocationClient",
                          }}
                          onChange={(e) =>
                            this.defaultChange(e.target.value, document)
                          }
                        >
                          {filterLocations.map((l: any) => {
                            return l[document].map(
                              (location: any, index: number) => {
                                return (
                                  <MenuItem key={index} value={location.id}>
                                    {location.defaultLocation ? (
                                      <Star
                                        className={
                                          this.props.classes.starIconDefault
                                        }
                                      />
                                    ) : (
                                      <StarBorder
                                        className={
                                          this.props.classes.starBorderIcon
                                        }
                                      />
                                    )}
                                    &nbsp; &nbsp;
                                    {location.street1
                                      ? `${location.street1}`
                                      : `Dirección # ${location.id}`}
                                  </MenuItem>
                                );
                              }
                            );
                          })}
                        </Select>
                      </FormControl>
                      <IconButton
                        className={this.props.classes.editIcon}
                        onClick={this.changeAddress(data)}
                      >
                        <Tooltip title="Editar direcciones" placement="top">
                          <EditIcon />
                        </Tooltip>
                      </IconButton>
                    </>
                  );
                },
              },
            ],
          },
        });
        this.setState({ dataLoading: false });
      }, 500);
    }
  }

  filterLocationsDocument(document: any) {
    const filter = this.state.clientLocations.filter((l: any) => l[document]);
    return filter;
  }

  getLocationsByClientDocument(document: string, listHome: boolean) {
    getApi()
      .admin()
      .clientLocationByDocument(document)
      .then((data) => {
        if (listHome) {
          this.setState({
            ...this.state,
            clientLocations: [
              ...this.state.clientLocations,
              { [document]: data },
            ],
          });
        } else {
          this.setState({
            clientLocations: data,
          });

          const newSchema: JSONSchema6 = JSON.parse(
            JSON.stringify(schemaAddress)
          );
          const location = newSchema.properties!.id as JSONSchema6;

          location.anyOf = data.map((l: any) => {
            return {
              type: "number",
              enum: [l.id],
              title: l.street1 || "",
            } as JSONSchema6;
          });

          this.setState({ schemaAddress: newSchema });
        }
      });
  }

  handleSubmit(e: ISubmitEvent<any>) {
    this.props.actions.save(e.formData);
    this.hideDialog();
  }
  handleSubmitAddress(e: ISubmitEvent<any>) {
    this.props.actions.updateLocation(e.formData),
      setTimeout(() => {
        this.setState({
          location: {
            id: 0,
            street1: "",
            street2: "",
            number: "",
            observation: "",
            lat: 0,
            lng: 0,
            defaultLocation: false,
          },
        });
        this.getLocationsByClientDocument(this.state.abm.document, false);
      }, 1000);
  }

  defaultChange(id: any, document: any) {
    const filterLocations = this.filterLocationsDocument(document);
    const idLocation = id;
    const alterLocations = filterLocations.map((location: any) =>
      location[document].filter((l: any) => {
        if (l.id === idLocation) {
          l.defaultLocation = true;
          return { ...l };
        } else {
          l.defaultLocation = false;
          return { ...l };
        }
      })
    );

    alterLocations.map((locations: any) => {
      return locations.map((l: any) => this.props.actions.updateLocation(l));
    });

    setTimeout(() => {
      this.setState({
        location: {
          id: 0,
          street1: "",
          street2: "",
          number: "",
          observation: "",
          lat: 0,
          lng: 0,
          defaultLocation: false,
        },
      });
    }, 1000);
  }

  filterLocation(id: number) {
    const dataLocation = this.state.clientLocations;
    return dataLocation.filter((l: any) => l.id === id);
  }

  editAddress(data: any) {
    if (data.id !== this.state.location.id) {
      const idLocationSelect = data.id;
      const dataFilter = this.filterLocation(idLocationSelect);
      const dataLocation = { ...dataFilter[0] };

      this.setState({
        location: {
          id: dataLocation.id || 0,
          street1: dataLocation.street1 || "",
          street2: dataLocation.street2 || "",
          number: dataLocation.number || "",
          observation: dataLocation.observation || "",
          defaultLocation: dataLocation.defaultLocation || false,
          lat: dataLocation.lat || 0,
          lng: dataLocation.lng || 0,
        },
      });
    }
  }

  changeAddress(data: any) {
    return (event: React.MouseEvent<HTMLElement>) => {
      this.setState({
        abm: { ...this.state.abm, document: data.document },
        openAddress: true,
        location: {
          id: 0,
          street1: "",
          street2: "",
          number: "",
          observation: "",
          lat: 0,
          lng: 0,
          defaultLocation: false,
        },
      });
      if (data.document !== null) {
        this.getLocationsByClientDocument(data.document, false);
      }
    };
  }

  sort(name: string) {
    return () => {
      this.setState({
        ...this.state,
        table: {
          ...this.state.table,
          sortBy: name,
          sortDirection: "desc",
        },
      });
    };
  }

  componentDidMount() {
    this.props.actions.fetch();
    this.setState({ dataLoading: true });
    setTimeout(() => {
      this.addColumnAddress(false);
    }, 2000);
  }

  hideDialog() {
    this.setState({
      abm: {
        ...this.state.abm,
        open: false,
      },
      openAddress: false,
    });
    this.addColumnAddress(true);
  }

  showDialog() {
    this.setState({
      abm: {
        id: "",
        name: "",
        email: "",
        document: "",
        phone: "",
        address: "",
        open: true,
      },
    });
  }

  filter(search: any) {
    const s = search == null ? this.state.searchText : search;
    this.props.actions.filter(s);
  }

  render() {
    const dataClientLocations = this.state.clientLocations;
    return (
      <Grid container spacing={24} className={this.props.classes.root}>
        <Grid item sm={12} md={12}>
          <SearchBox
            placeHolder="Ingrese CI y presione ENTER"
            doSearch={(search) => {
              this.setState({ searchText: search });
              this.filter(search);
            }}
            hasFilter={false}
          />
        </Grid>
        <Grid item sm={12} md={12} lg={12}>
          {this.state.dataLoading ? (
            <LinearProgress />
          ) : (
            <>
              <div
                style={{
                  textAlign: "right",
                }}
              >
                <span style={{ fontSize: 14 }}>
                  <InfoIcon style={{ paddingTop: 8 }} color="primary" />
                  &nbsp; La actualización del usuario se realiza a través de la
                  APP de cliente
                </span>
              </div>
              <br />

              <AsyncTable
                columnDefinition={this.state.table.columnData}
                title="Clientes"
                data={this.props.data.data}
                defaultOrder={{
                  name: "name",
                  direction: "desc",
                }}
                headerButtons={
                  <>
                    <div style={{ float: "right", marginTop: 5 }}>
                      <Tooltip title="Agregar cliente">
                        <IconButton onClick={this.showDialog}>
                          <AddIcon />
                        </IconButton>
                      </Tooltip>
                    </div>
                  </>
                }
              />
            </>
          )}
        </Grid>
        {
          <Dialog open={this.state.abm.open} maxWidth="md" fullWidth={true}>
            <Paper className={this.props.classes.abm}>
              <EnhancedSchemaForm
                schema={schema}
                formData={this.state.abm}
                onSubmit={this.handleSubmit}
                uiSchema={uiSchema}
              >
                <div>
                  <Button variant="contained" onClick={this.hideDialog}>
                    Cancelar
                  </Button>
                  &nbsp;
                  <Button variant="contained" color="primary" type="submit">
                    Aceptar
                  </Button>
                </div>
              </EnhancedSchemaForm>
            </Paper>
          </Dialog>
        }
        {
          <Dialog open={this.state.openAddress} maxWidth="md" fullWidth={true}>
            <Paper className={this.props.classes.abm}>
              <EnhancedSchemaForm
                schema={this.state.schemaAddress}
                formData={this.state.location}
                onSubmit={(e) => {
                  this.handleSubmitAddress(e);
                }}
                onChange={(e) => this.editAddress(e.formData)}
                uiSchema={uiSchema}
              >
                {this.state.location.id > 0 && (
                  <div className={this.props.classes.starDefault}>
                    {this.state.location.defaultLocation ? (
                      <Star className={this.props.classes.starIconDefault} />
                    ) : (
                      <StarBorder
                        className={this.props.classes.starBorderIcon}
                      />
                    )}
                    &nbsp; &nbsp;
                    <span>Dirección preferida</span>
                  </div>
                )}
                <div>
                  <Button variant="contained" onClick={this.hideDialog}>
                    Cancelar
                  </Button>
                  &nbsp;
                  <Button
                    variant="contained"
                    disabled={!this.state.location.id}
                    color="primary"
                    type="submit"
                  >
                    Guardar
                  </Button>
                </div>
              </EnhancedSchemaForm>
            </Paper>
          </Dialog>
        }
      </Grid>
    );
  }
}

const mapStateToProps = (state: IStore, ownProps: ClientsProps) => ({
  ...ownProps,
  data: state.client,
  user: state.auth.user,
});

const styled = withStyles(styles as any)(Clients);
const connected = connect(mapStateToProps, bindActions(ClientActions))(styled);

export default connected as ComponentClass<Partial<ClientsProps>>;



// WEBPACK FOOTER //
// ./src/pages/client.tsx